module.exports = __webpack_public_path__ + "img/student-3.d8551c88.jpg";